module.exports = __webpack_public_path__ + "img/Bodice-Front-B3-Gc-Db-Ee.7b30c842.png";